/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export default class PaletteAlgorithms{

	static createPaletteViaHue( numSwatches, hslColor ){

		let colors = [];
		let incrementAngle = 360/numSwatches;
		let startAngle = hslColor.hue;

		for (let i = 0; i < numSwatches; i++){
			let currAngle = startAngle + (incrementAngle * i);
			if(currAngle < 0){
				currAngle = 360 - currAngle;
			}else if(currAngle > 360){
				currAngle = currAngle - 360;
			}
			colors.push({
				hue: currAngle,
				sat: hslColor.sat,
				light: hslColor.light
			});
		}
		return colors;
	}

	static createPaletteViaLight( numSwatches, hslColor ){
		let colors = [];
		let startLight = hslColor.light;
		// interval is only needed if there is more than 1
		let interval = numSwatches > 1 ? startLight / (numSwatches - 1) : 0;
		for ( let i = 0; i < numSwatches; i++ ){
			colors.push({
				hue: hslColor.hue,
				sat: hslColor.sat,
				light: startLight - i * (interval)
			});
		}
		return colors;
	}
}


// WEBPACK FOOTER //
// ./src/js/utilities/PaletteAlgorithms.js